import React, { useEffect } from 'react';
import { Calendar, LocaleConfig } from 'react-native-calendars';

import * as Colors from './utils/Colors';
import { DefaultCalendarTheme } from './utils/Constants';
import { Icon } from 'react-native-elements';
import { Text, StyleSheet, View } from 'react-native';
import DateTimePickerProperties from './properties/Properties';
import {
  parseDateToCalendarFormat,
  parseDateOrUndefined,
} from './utils/DateUtils';

LocaleConfig.locales['en'] = {
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'June',
    'September',
    'October',
    'November',
    'December',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Jun',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  dayNames: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  dayNamesShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  today: 'Today',
};

LocaleConfig.defaultLocale = 'en';

const CalendarView = (
  props = {
    calendarTheme: DefaultCalendarTheme,
  }
) => {
  const [selected, setSelected] = React.useState(
    parseDateOrUndefined(props.selectedDate)
  );
  const [startDate, setStartDate] = React.useState(
    parseDateOrUndefined(props.startDate)
  );

  /*  React.useEffect(() => {
    let selectedDate = parseDateOrUndefined(props.selectedDate);
    console.log(
      `Calendar Startdate ${parseDateOrUndefined(
        props.startDate
      )}  ${parseDateOrUndefined(props.currentDate)} `
    );
  }, []); */

  const Arrow = () => {
    return <Icon name="chevron-back-outline" color="#900" />;
  };

  const onDayPress = (day) => {
    setSelected(day.dateString);
    props.onDateSelect(day);
  };

  function renderCustomHeader(date) {
    const header = date.toString('yyyy-MMMM');
    const [month, year] = header.split(' ');
    const textStyle = {
      fontSize: 18,
      fontWeight: 'bold',
      paddingTop: 10,
      paddingBottom: 10,
      color: Colors.PrimaryColor,
      paddingRight: 5,
    };

    return (
      <View style={styles.header}>
        <Text style={[styles.month, textStyle]}>{`${month}`}</Text>
      </View>
    );
  }
  console.log(
    `Calendar Startdate ${parseDateOrUndefined(
      props.startDate
    )}  ${parseDateOrUndefined(props.currentDate)} `
  );
  return (
    <Calendar
      theme={props.calendarTheme}
      // Initially visible month. Default = Date()
      current={parseDateOrUndefined(props.currentDate)}
      // Minimum date that can be selected, dates before minDate will be grayed out. Default = undefined
      minDate={startDate}
      // Maximum date that can be selected, dates after maxDate will be grayed out. Default = undefined
      maxDate={parseDateOrUndefined(props.endDate)}
      // Handler which gets executed on day press. Default = undefined
      onDayPress={onDayPress}
      // Handler which gets executed on day long press. Default = undefined
      onDayLongPress={(day) => {
        console.log('selected day', day);
      }}
      // Month format in calendar title. Formatting values: http://arshaw.com/xdate/#Formatting
      monthFormat={'yyyy- MMM'}
      // Handler which gets executed when visible month changes in calendar. Default = undefined
      onMonthChange={(month) => {
        console.log('month changed', month);
      }}
      // Hide month navigation arrows. Default = false
      hideArrows={true}
      // Replace default arrows with custom ones (direction can be 'left' or 'right')
      renderArrow={(_direction) => <Arrow />}
      // Do not show days of other months in month page. Default = false
      hideExtraDays={true}
      // If hideArrows=false and hideExtraDays=false do not switch month when tapping on greyed out
      // day from another month that is visible in calendar page. Default = false
      disableMonthChange={false}
      // If firstDay=1 week starts from Monday. Note that dayNames and dayNamesShort should still start from Sunday.
      firstDay={1}
      // Hide day names. Default = false
      hideDayNames={false}
      // Show week numbers to the left. Default = false
      showWeekNumbers={false}
      // Handler which gets executed when press arrow icon left. It receive a callback can go back month
      onPressArrowLeft={(subtractMonth) => subtractMonth()}
      // Handler which gets executed when press arrow icon right. It receive a callback can go next month
      onPressArrowRight={(addMonth) => addMonth()}
      // Disable left arrow. Default = false
      disableArrowLeft={true}
      // Disable right arrow. Default = false
      disableArrowRight={true}
      // Disable all touch events for disabled days. can be override with disableTouchEvent in markedDates
      disableAllTouchEventsForDisabledDays={true}
      // Replace default month and year title with custom one. the function receive a date as parameter.
      renderHeader={renderCustomHeader}
      // Enable the option to swipe between months. Default = false
      enableSwipeMonths={true}
      markedDates={{
        [selected]: {
          selected: true,
          disableTouchEvent: true,
          selectedColor: props.calendarTheme.selectedDayBackgroundColor,
          selectedTextColor: props.calendarTheme.selectedDayTextColor,
        },
      }}
    />
  );
};

export default CalendarView;

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-start',
    marginTop: 10,
    marginBottom: 10,
  },
  month: {
    marginLeft: 5,
  },
  year: {
    marginRight: 5,
  },
});
